module.exports = __webpack_public_path__ + "static/media/icon-desk.6025cc4c.svg";